module.exports = __webpack_public_path__ + "static/img/12061D_B_02_20170623_LC.ff29860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12061D_B_02_20170623_LC.png
// module id = oYcd
// module chunks = 0